/*
  DIREVULF — Shiprocket Smart Cart (Fastrr Cart) is the store's only cart.

  The theme still renders its own slide-in bag and /cart page, and theme.js /
  cart.js still open the bag after "Add to cart" and from the header bag icon.
  This hands every one of those over to Shiprocket's cart:

  1. Header bag icon / any link to /cart: opens the Shiprocket cart instead.
  2. Theme bag opening for any other reason (after Add to cart, CYO studio,
     wishlist "move to bag" …): the theme bag is closed straight away and the
     Shiprocket cart opens with the fresh cart.
  3. Visiting /cart directly: goes back to the previous page on this site (or
     home) and opens the Shiprocket cart there.
  4. When the Shiprocket cart changes quantities, the header bag count is
     refreshed from Shopify's /cart.js.

  If the Shiprocket cart never loads (8 s), the theme's own bag is used, so a
  shopper is never left without a cart.
*/
(function () {
  if (window.__dvSrCart) return;
  window.__dvSrCart = true;

  var WAIT_MS = 8000;
  var FLAG = 'dvOpenSrCart';
  var allowThemeBag = false;

  function ready() { return typeof window.slideShiprocketSmartCartInFrame === 'function'; }

  function whenReady(cb) {
    var start = Date.now();
    (function poll() {
      if (ready()) return cb(true);
      if (Date.now() - start > WAIT_MS) return cb(false);
      setTimeout(poll, 120);
    })();
  }

  function openThemeBag() {
    allowThemeBag = true;
    var t = document.querySelector('[data-dv-open="#DvCartDrawer"]');
    if (t) t.click();
    setTimeout(function () { allowThemeBag = false; }, 1500);
  }

  function openSrCart() {
    whenReady(function (ok) {
      if (!ok) { openThemeBag(); return; }
      try { window.slideShiprocketSmartCartInFrame(true); } catch (e) { openThemeBag(); }
    });
  }
  window.dvOpenCart = openSrCart;

  // 3. /cart page → previous page (or home) with the Shiprocket cart open.
  if (/^\/cart\/?$/.test(location.pathname)) {
    try { sessionStorage.setItem(FLAG, '1'); } catch (e) {}
    var back = '/';
    try {
      if (document.referrer) {
        var r = new URL(document.referrer);
        if (r.origin === location.origin && !/^\/cart\/?$/.test(r.pathname)) back = r.pathname + r.search;
      }
    } catch (e) {}
    location.replace(back);
    return;
  }
  try {
    if (sessionStorage.getItem(FLAG) === '1') {
      sessionStorage.removeItem(FLAG);
      openSrCart();
    }
  } catch (e) {}

  // 1. Header bag icon and links to /cart.
  document.addEventListener('click', function (e) {
    if (allowThemeBag) return;
    var el = e.target && e.target.closest && e.target.closest('[data-dv-open="#DvCartDrawer"], [data-dv-cart-toggle], a[href="/cart"], a[href^="/cart?"], a[href="' + location.origin + '/cart"]');
    if (!el) return;
    if (el.closest('#shiprocket-smart-cart-root')) return;
    e.preventDefault();
    e.stopImmediatePropagation();
    openSrCart();
  }, true);

  // 2. Theme bag opened programmatically (after Add to cart etc.).
  document.addEventListener('dv:overlay:open', function (e) {
    var el = e.detail && e.detail.el;
    if (!el || el.id !== 'DvCartDrawer' || allowThemeBag) return;
    var close = el.querySelector('[data-dv-close]');
    if (close) close.click(); else el.hidden = true;
    openSrCart();
  });

  // 4. Keep the header bag count in step with the Shiprocket cart.
  var countTimer;
  function refreshCount() {
    clearTimeout(countTimer);
    countTimer = setTimeout(function () {
      fetch('/cart.js', { credentials: 'same-origin' }).then(function (r) { return r.json(); }).then(function (cart) {
        var n = cart.item_count || 0;
        document.querySelectorAll('[data-dv-cart-count]').forEach(function (node) {
          node.textContent = String(n);
          node.setAttribute('data-count', String(n));
          node.hidden = n <= 0;
        });
      }).catch(function () {});
    }, 400);
  }
  // Any cart change made on the page (the Shiprocket cart uses fetch for
  // /cart/add, /cart/change, /cart/update, /cart/clear) refreshes the count.
  var CHANGE = /\/cart\/(add|change|update|clear)(\.js)?(\?|$)/;
  if (window.fetch && !window.fetch.__dvWrapped) {
    var origFetch = window.fetch;
    var wrapped = function (input) {
      var url = typeof input === 'string' ? input : (input && input.url) || '';
      var p = origFetch.apply(this, arguments);
      if (CHANGE.test(url)) p.then(refreshCount, function () {});
      return p;
    };
    wrapped.__dvWrapped = true;
    window.fetch = wrapped;
  }
  // Closing the Shiprocket cart also refreshes it, as a safety net.
  function watchRoot() {
    var root = document.getElementById('shiprocket-smart-cart-root');
    if (!root) { setTimeout(watchRoot, 500); return; }
    new MutationObserver(refreshCount).observe(root, { subtree: true, attributes: true, attributeFilter: ['style'] });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', watchRoot); else watchRoot();
})();
